export const passkeysFaqItems = [
  {
    title: 'Are passkeys the replacement for passwords?',
    body: (
      <div className="pr-4 font-medium text-md ">
        <p>
          Passkeys are a replacement for your password. With passkeys, you can sign into your USCIS online account using
          your face, fingerprint, or PIN. Signing in with a passkey is simple, fast, and helps protect you against
          phishing attacks.
        </p>
        <br></br>
        <p>Passkeys are supported on desktop and mobile browsers.</p>
      </div>
    ),
  },
  {
    title: 'How does authentication with passkeys work?',
    body: (
      <div className="pr-4 font-medium text-md ">
        <p>
          Instead of sending a password over the internet, your device generates a pair of keys: a private key and a
          public key.
        </p>
        <br />
        <ul className="list-disc px-8 font-medium text-md ">
          <li className="pb-2">The private key is stored securely on your device</li>
          <li className="pb-2">The public key is resgistered with the website or application</li>
        </ul>
        <br />
        <p>
          When you want to sign in to the website or application, your device has to prove that it has the private key.
          After you unlock your private key, your device digitally signs a challenge from the website or application.
          The website or application verifies the signature using the public key and grants you access.
        </p>
      </div>
    ),
  },
  {
    title: 'Are passkeys considered multi-factor?',
    body: (
      <div className="pr-4 font-medium text-md ">
        Yes, passkeys are considered a form of multi-factor authentication. When you use a passkey, you must use a
        device that stores the passkey (somehthing you have) and unlock it with biographic information or a PIN
        (something you are, or something you know).
      </div>
    ),
  },
  {
    title: 'Are passkeys phishing resistant?',
    body: (
      <div className="pr-4 font-medium text-md ">
        Yes, passkeys are phishing resistant. When they are created, passkeys are associated with the specific domain
        that the website or app are registered with. A passkey created for your USCIS online account can only be used
        with your USCIS online account. While a user can be tricked into landing on a similar looking website, they
        can't present their passkey to the malicious website. Their device won't allow it.
      </div>
    ),
  },
  {
    title: 'Can I use passkeys across multiple devices?',
    body: (
      <div className="pr-4 font-medium text-md ">
        <p>
          Yes, passkeys allow you to use cross device authentication: a passkey might be stored on one device, and you
          can use it for sign in on another device.
        </p>
        <br />
        <p>This is handy, for example, when you need to sign in on a new device.</p>
        <br />
        <p>
          To link your devices together for cross device authentication, you must scan a QR code that's generated on the
          device where you want to sign in. During this process, a proximity check takes place to ensure that the
          passkey is only being used for authentication on a link device that's nearby. With this technology, you can
          rest assured that your passkey can't be used by a remote attacker to gain access from far away.
        </p>
      </div>
    ),
  },
];
